import { Logger }		from "@geotoura/shared/logger";
import * as commonModel	from "@geotoura/shared/commonModel";
import * as upModel		from "@geotoura/shared/upModel";

import * as util				from "@geotoura/up/util";
import { UpData }				from "@geotoura/up/upData";
import { MapView, ScreenSize }	from "@geotoura/up/model";

const logger	= Logger.create("initHelper");

// this position was chosen only for the looks
export const defaultMapView:MapView	= {
	zoom: 7,
	center: {
		lat:	commonModel.Latitude.brand(37.42),
		lng:	commonModel.Longitude.brand(16.46),
	},
};

export const destinationMapView	= (region:upModel.Region, destination:upModel.Marker):MapView	=> ({
	zoom:	region.zoom,
	center:	destination.c,
});

export const regionMapView	= (region:upModel.Region):MapView	=> ({
	zoom:	region.zoom,
	center:	region.center,
});

export const territoryMapView	= (territory:upModel.Territory):MapView	=> ({
	zoom:	territory.zoom,
	center:	territory.center,
});

export const currentScreenSize	= ():ScreenSize	=> ({
	width:			window.innerWidth,
	height:			window.innerHeight,
	// we are limited here currently because destination images are maximum 1000px wide
	// and hotel images only 700px
	orientation:	window.innerWidth < 1000 ? "portrait" : "landscape",
	mode:			window.innerWidth < 1300 ? "compact" : "loose",
	canHover:		window.matchMedia("(any-hover: hover)").matches,
});

export const loadSavedRoute = (upData:UpData, routeVersion:string):ReadonlyArray<upModel.RouteItem>|null	=> {
	// check version of saved route
	if (localStorage.getItem("routeVersion") !== routeVersion ) {
		logger.error("Saved route existed but routeVersion does not match, discarding route", localStorage.getItem("routeVersion"), routeVersion);
		return null;
	}

	const route = JSON.parse(localStorage.getItem("route") as string) as ReadonlyArray<upModel.RouteItem>;
	if (route === null || route.length === 0 ) return null;

	// verify all destinations in route against upData
	if (route.some(it => !upData.destination.has(it.id))) {
		logger.error("Saved route existed but contained invalid destinations, discarding route");
		return null;
	}

	// TODO brand we have to validate hotels here, too, right?

	return route;
};

export type SavedRouteMapViewData = Readonly<{
	region:	upModel.Region,
	marker:	upModel.Marker,
}>;

export const getSavedRouteMapViewData = (upData:UpData, route:ReadonlyArray<upModel.RouteItem>):SavedRouteMapViewData|null => {
	if (route.length < 1)	return null;
	const item	= route[0];

	const marker	= upData.destination.getOrNull(item.id);
	if (marker === null)	return null;

	const region	= upData.region.getOrNull(marker.r);
	if (region === null)	return null;

	return { region, marker };
};

export const calcDuration = (route:ReadonlyArray<upModel.RouteItem>):number => util.sumBy(route, it => it.nights) + 1;
